PathLayer = require './path-layer'

module.exports = App.ArrayPathLayerComponent = PathLayer.extend
  leafletRequiredOptions: [ 'locations' ]
  leafletProperties: [ 'locations.[]:setLatLngs' ]